module.exports = __webpack_public_path__ + "static/media/AdminNómina_Vacaciones.3cdb1124.svg";